import { z } from "zod"
import {
  type Column,
  columnSchema,
  DEFAULT_COLUMNS,
  withRegistration,
} from "./columns"
import { type Grouping, groupingSchema } from "./grouping"
import { overviewSearchFields } from "./overview"

export const FLEET = { limit: 1000 }

export const LIST_TABS = ["overview", "all"] as const

const listTabSchema = z.enum(LIST_TABS)

export type ListTab = z.infer<typeof listTabSchema>

export function listTabLabel(tab: ListTab): string {
  switch (tab) {
    case "all":
      return "All aircraft"
    case "overview":
      return "Overview"
  }
}

const directionSchema = z.enum(["asc", "desc"])

export type Direction = z.infer<typeof directionSchema>

export const aircraftSearchSchema = z.object({
  tab: listTabSchema.optional().catch(undefined),
  search: z.string().optional().catch(undefined),
  manufacturer: z.array(z.string()).optional().catch(undefined),
  model: z.array(z.string()).optional().catch(undefined),
  updater: z.array(z.string()).optional().catch(undefined),
  group: groupingSchema.optional().catch(undefined),
  subgroup: groupingSchema.optional().catch(undefined),
  columns: z.array(columnSchema).optional().catch(undefined),
  sort: columnSchema.optional().catch(undefined),
  direction: directionSchema.optional().catch(undefined),
  ...overviewSearchFields,
})

export type AircraftSearch = z.infer<typeof aircraftSearchSchema>

export type AircraftDisplay = {
  group: Grouping | undefined
  subgroup: Grouping | undefined
  columns: Column[]
  sort: Column
  direction: Direction
}

export function displayOf(search: AircraftSearch): AircraftDisplay {
  const group = search.group
  return {
    group,
    subgroup: group && search.subgroup !== group ? search.subgroup : undefined,
    columns: search.columns
      ? withRegistration(search.columns)
      : DEFAULT_COLUMNS,
    sort: search.sort ?? "registration",
    direction: search.direction ?? "asc",
  }
}
